// extracted by mini-css-extract-plugin
export var black = "_3m-6";
export var brand = "_3m-1";
export var ddefault = "_3m-0";
export var error = "_3m-3";
export var gray = "_3m-2";
export var highContrast = "_3m-8";
export var outline = "_3m-7";
export var success = "_3m-5";
export var warning = "_3m-4";